import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CCol
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormPurchaseOrder from '../general-input-form/FormPurchaseOrder'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormProjectTerms from '../general-input-form/FormProjectTerms'
import FormInvoicingTermsCondition from '../general-input-form/FormInvoicingTermsCondition'
import { singleProjectProgressStatusOptionSelect } from '../../../helpers/format-options'

const AppForm = ({
  values,
  handleChange,
  errors,
  onDateChange,
  clientOptions,
  handleSelectClient,
  handleSearchInput,
  handleAddPurchaseOrders,
  handleChangeInvoiceRecipients,
  handleRemovePurchaseOrders,
  setOpenFilePreview,
  handleConfirmDelete,
  handleSelectEmployee,
  employees,
  employeeOptions,
  handleAddProjectTerms,
  handleChangeProjectTerms,
  handleRemoveProjectTerms,
  handleSelectPaymentTempo,
  paymentTempoOptions,
  paymentTempoValue,
  handleSelectProgressStatus,
  handleCheckbox,
  handleShowModalCreate
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='project_name'
          name='project_name'
          colSize='6'
          inputLabel='Project Name'
          className='mb-3'
          placeholder='Enter project name...'
          value={values.project_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.project_name}
          invalid={errors.project_name}
        />
        <FormPrice
          id='project_value'
          name='project_value'
          colSize='3'
          inputLabel='Project Value'
          placeholder='Enter project value...'
          value={values.project_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.project_value}
          invalid={errors.project_value}
        />
        <FormPrice
          id='project_tax_value'
          name='project_tax_value'
          colSize='3'
          inputLabel='Tax and other fees'
          placeholder='Enter project tax and other fees...'
          value={values.project_tax_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.project_tax_value}
          invalid={errors.project_tax_value}
        />
        <FormTextAreaInput
          id='project_description'
          name='project_description'
          colSize='6'
          inputLabel='Project Description'
          className='mb-3'
          placeholder='Enter project description...'
          rows='5'
          value={values.project_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.project_description}
          invalid={errors.project_description}
        />
        <FormDatePicker 
          id='project_start_date'
          name='project_start_date'
          colSize='3'
          inputLabel='Project Start Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.project_start_date}
          feedbackInvalid={errors.project_start_date}
          invalid={errors.project_start_date}
        />
        <FormDatePicker 
          id='project_end_date'
          name='project_end_date'
          colSize='3'
          inputLabel='Project End Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.project_end_date}
          feedbackInvalid={errors.project_end_date}
          invalid={errors.project_end_date}
          minDate={values.project_start_date ? moment(values.project_start_date).add(1, 'days') : null}
        />
        <FormSelectInput 
          id='client_value'
          name='client_value'
          colSize='6'
          className='mb-3'
          inputLabel='Client Name'
          selectOptions={clientOptions}
          value={values.client_value}
          handleSelectInput={handleSelectClient}
          feedbackInvalid={errors.client_value || errors.client_value?.name}
          invalid={errors.client_value || errors.client_value?.name}
          disabled={false}
          isShowCreatedModal={true}
          handleSearchInput={handleSearchInput}
          handleShowModalCreate={handleShowModalCreate}
          placeholder='Select client...'
        />
        <FormSelectInput 
          id='project_employees'
          name='project_employees'
          colSize='6'
          inputLabel='Assigned Employee'
          className='mb-3'
          selectOptions={employeeOptions}
          value={employees}
          handleSelectInput={handleSelectEmployee}
          feedbackInvalid={errors.project_employees}
          invalid={errors.project_employees}
          disabled={false}
          multiple={true}
          placeholder='Please select employee...'
        />
        {
          values.project_payment_tempo == 'Others' ? (
            <CCol lg={6}>
              <FormSelectInput 
                id='project_payment_tempo'
                name='project_payment_tempo'
                colSize='12'
                className='mb-3'
                inputLabel='Payment Tempo'
                selectOptions={paymentTempoOptions}
                value={paymentTempoValue}
                handleSelectInput={handleSelectPaymentTempo}
                feedbackInvalid={errors.project_payment_tempo}
                invalid={errors.project_payment_tempo}
                disabled={false}
              />
              <FormTextInput 
                id='project_other_payment_tempo'
                name='project_other_payment_tempo'
                colSize='12'
                className='mb-3'
                placeholder='Please input description...'
                value={values.project_other_payment_tempo}
                handleTextInput={handleChange}
                feedbackInvalid={errors.project_other_payment_tempo}
                invalid={errors.project_other_payment_tempo}
              />
            </CCol>
          ) : (
            <FormSelectInput 
              id='project_payment_tempo'
              name='project_payment_tempo'
              colSize='6'
              className='mb-3'
              inputLabel='Payment Tempo'
              selectOptions={paymentTempoOptions}
              value={paymentTempoValue}
              handleSelectInput={handleSelectPaymentTempo}
              feedbackInvalid={errors.project_payment_tempo}
              invalid={errors.project_payment_tempo}
              disabled={false}
              placeholder="Select payment tempo..."
            />
          )
        }
        <FormSelectInput 
          id='project_progress_status'
          name='project_progress_status'
          colSize='6'
          className='mb-3'
          inputLabel='Progress Status'
          selectOptions={singleProjectProgressStatusOptionSelect()}
          value={values.project_progress_status ? singleProjectProgressStatusOptionSelect()?.filter((val) => val.value == values.project_progress_status)[0] : null}
          handleSelectInput={handleSelectProgressStatus}
          feedbackInvalid={errors.project_progress_status}
          invalid={errors.project_progress_status}
          disabled={false}
          placeholder="Select status..."
        />
        <FormInvoicingTermsCondition 
          id='invoicing_terms_condition'
          type={'checkbox'}
          colSize={12}
          className='mb-3'
          inputLabel='Invoicing Terms & Condition'
          handleCheck={handleCheckbox}
          handleTextInput={handleChange}
          value={values}
        />
        <FormSwitchInput 
          id='is_purchase_order'
          name='is_purchase_order'
          colSize='6'
          inputLabel='Purchase Order?'
          className='mb-3'
          handleSwitch={handleChange}
          value={values.is_purchase_order}
          invalid={errors?.is_purchase_order}
        />
      </CRow>
      {
        values.is_purchase_order && (
          <CRow className="mb-4">
            <FormPurchaseOrder 
              inputLabel={'Purchase Order'}
              className={'mb-3'}
              purchase_orders={values.project_purchase_orders}
              errors={errors}
              handleChange={handleChangeInvoiceRecipients}
              handleAddPurchaseOrder={handleAddPurchaseOrders}
              handleRemovePurchaseOrder={handleRemovePurchaseOrders}
              isDetail={false}
              setOpenFilePreview={setOpenFilePreview}
              handleConfirmDelete={handleConfirmDelete}
            />
          </CRow>
        )
      }
      <CRow>
        <FormProjectTerms 
          inputLabel={'Payment Terms'}
          className={'mb-3'}
          project_terms={values.project_terms}
          errors={errors}
          handleChange={handleChangeProjectTerms}
          handleAddProjectTerms={handleAddProjectTerms}
          handleRemoveProjectTerms={handleRemoveProjectTerms}
          isDetail={false}
        />
      </CRow>
    </>
  )
}

export default AppForm